import"react";import{isNavigator as o}from"./misc/util.js";var i=o?navigator:void 0;i&&(i.connection||i.mozConnection||i.webkitConnection);
//# sourceMappingURL=useNetworkState.js.map
